import {createApplication} from '@angular/platform-browser';
import {createCustomElement} from '@angular/elements';
import {MijnVacaturesPageComponent} from './app/components/mijn-vacatures-page/mijn-vacatures-page.component';
import {appConfig} from './app/app.config';

createApplication(appConfig)
    .then((app) => {
      const myComponent = createCustomElement(MijnVacaturesPageComponent, {injector: app.injector});
      customElements.define('mijnvacatures-widget', myComponent);
    })
    .catch((err) => { console.error(err); });